import { computed, ref } from 'vue-demi';
import { DEFAULT_STATUS } from './../../../pages/dashboard/perf/const/index';
export const initVideoStore = (): Record<string, any> => ({
  videoStage: ref(0),
  selectedVid: ref(''),
});
export const initCampaignList = (): Record<string, any> => ({
  campaignListData: ref([]),
  nonFilterCampaignListData: ref([]),
  statusFilter: ref([DEFAULT_STATUS]),
  objectiveFilter: ref([]),
  sourceFilter: ref(['TTAM'])
});
export const state = {
  campaignList: initCampaignList(),
  video: initVideoStore(),
};

export const getters = {
  identityFormData: computed(() => ({
    videoStage: state.video.videoStage.value,
    selectedVid: state.video.selectedVid.value,
  })),
  campaignListData: computed(() => ({
    campaignList: state.campaignList.campaignListData.value,
    nonFilterCampaignListData: state.campaignList.nonFilterCampaignListData.value,
    statusFilter: state.campaignList.statusFilter.value,
    sourceFilters: state.campaignList.sourceFilter.value,
    objectiveFilter: state.campaignList.objectiveFilter.value,
  })),
};
